<div class="main">
    <div class="container-fluid">
        <!-- Header Section -->
        <div class="faqs-header d-flex flex-wrap justify-content-between align-items-center m-4">
            <div class="faqs-title-container mb-3 mb-md-0">
                <button class="btn back-btn p-0 mb-2 d-flex align-items-center" (click)="goBack()"
                    aria-label="Go back to FAQs">
                    <i class="fas fa-arrow-left me-2"></i>
                    Go back to FAQs
                </button>
                <div class="d-flex flex-wrap align-items-center gap-2 gap-md-3 mb-2">
                    <h3 class="mb-0">{{ faqDetails?.faqId || faqId }}</h3>
                    <app-status-badge 
                        *ngIf="faqDetails?.status"
                        [text]="faqDetails.status"
                        [color]="getStatusColor(faqDetails.status)"
                        [size]="'medium'">
                    </app-status-badge>
                </div>
                <span>
                    <a [routerLink]="['/' + AppConstants.ROUTES.HOME]"
                        class="faqs-header-title breadcrumb-link">Dashboard <i class="lni lni-chevron-right"
                            aria-hidden="true"></i></a>
                    <a [routerLink]="['/' + AppConstants.ROUTES.FAQS]"
                        class="faqs-header-title breadcrumb-link">FAQs <i class="lni lni-chevron-right"
                            aria-hidden="true"></i></a>
                    <span>{{ faqDetails?.faqId || faqId }}</span>
                </span>
            </div>
            <div class="d-flex align-items-center gap-3 action-buttons-header">
                <button 
                    class="btn action-btn-pink" 
                    (click)="publishFAQ()" 
                    aria-label="Publish FAQ"
                    [disabled]="faqDetails?.status?.toLowerCase() === 'published'">
                    Publish
                </button>
                <button 
                    class="btn action-btn-purple" 
                    (click)="editFAQ()" 
                    aria-label="Edit FAQ"
                    [disabled]="faqDetails?.status?.toLowerCase() !== 'draft'">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="me-2">
                        <path d="M8 2H3.33333C2.97971 2 2.64057 2.14048 2.39052 2.39052C2.14048 2.64057 2 2.97971 2 3.33333V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V8" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12.2494 1.75015C12.5146 1.48493 12.8743 1.33594 13.2494 1.33594C13.6245 1.33594 13.9842 1.48493 14.2494 1.75015C14.5146 2.01537 14.6636 2.37508 14.6636 2.75015C14.6636 3.12522 14.5146 3.48493 14.2494 3.75015L8.24075 9.75948C8.08244 9.91765 7.88688 10.0334 7.67208 10.0962L5.75674 10.6562C5.69938 10.6729 5.63857 10.6739 5.58068 10.6591C5.5228 10.6442 5.46996 10.6141 5.42771 10.5719C5.38546 10.5296 5.35534 10.4768 5.34051 10.4189C5.32568 10.361 5.32668 10.3002 5.34341 10.2428L5.90341 8.32748C5.96643 8.11285 6.08243 7.91752 6.24075 7.75948L12.2494 1.75015Z" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Edit
                </button>
                <button 
                    class="btn action-btn-white" 
                    (click)="deleteFAQ()" 
                    aria-label="Delete FAQ"
                    [disabled]="faqDetails?.status?.toLowerCase() !== 'draft'">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="me-2">
                        <path d="M6.66602 7.33398V11.334" stroke="#4E4D50" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M9.33398 7.33398V11.334" stroke="#4E4D50" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12.6673 4V13.3333C12.6673 13.687 12.5268 14.0261 12.2768 14.2761C12.0267 14.5262 11.6876 14.6667 11.334 14.6667H4.66732C4.3137 14.6667 3.97456 14.5262 3.72451 14.2761C3.47446 14.0261 3.33398 13.687 3.33398 13.3333V4" stroke="#4E4D50" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M2 4H14" stroke="#4E4D50" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M5.33398 4.00065V2.66732C5.33398 2.3137 5.47446 1.97456 5.72451 1.72451C5.97456 1.47446 6.3137 1.33398 6.66732 1.33398H9.33398C9.68761 1.33398 10.0267 1.47446 10.2768 1.72451C10.5268 1.97456 10.6673 2.3137 10.6673 2.66732V4.00065" stroke="#4E4D50" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Delete
                </button>
            </div>
        </div>

        <!-- Main Content - Two Column Layout -->
        <div class="row m-2 m-md-4">
            <fieldset class="content-fieldset mb-4">
                <!-- Left Column -->
                <div class="col-12 col-md-8 mb-4 mb-md-0">
                    <!-- FAQ Information Section -->
                    <fieldset class="content-fieldset mb-4">
                        <legend class="section-legend d-flex justify-content-between align-items-center w-100">
                            <span>FAQ Information</span>
                            <app-status-badge 
                                *ngIf="faqDetails?.status"
                                [text]="faqDetails.status"
                                [color]="getStatusColor(faqDetails.status)"
                                [size]="'large'">
                            </app-status-badge>
                        </legend>
                        
                        <!-- Linked Tender -->
                        <div class="info-item mb-4" *ngIf="faqDetails?.linkedTender">
                            <div class="info-label mb-2">Linked Tender</div>
                            <a [routerLink]="['/' + AppConstants.ROUTES.TENDER, faqDetails.linkedTender.tenderId]" class="linked-tender-link">
                                {{ faqDetails.linkedTender.tenderId }} - {{ faqDetails.linkedTender.title }}
                            </a>
                        </div>

                        <!-- Category -->
                        <div class="info-item mb-4" *ngIf="faqDetails?.category">
                            <div class="info-label mb-2">Category</div>
                            <div class="category-value d-flex align-items-center gap-2">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.39132 1.72416C8.14133 1.4741 7.80224 1.33357 7.44865 1.3335H2.66732C2.3137 1.3335 1.97456 1.47397 1.72451 1.72402C1.47446 1.97407 1.33398 2.31321 1.33398 2.66683V7.44816C1.33406 7.80176 1.47459 8.14084 1.72465 8.39083L7.52732 14.1935C7.83033 14.4946 8.24015 14.6636 8.66732 14.6636C9.09449 14.6636 9.50431 14.4946 9.80732 14.1935L14.194 9.80683C14.4951 9.50382 14.6641 9.094 14.6641 8.66683C14.6641 8.23966 14.4951 7.82984 14.194 7.52683L8.39132 1.72416Z" stroke="#99A1AF" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M4.99935 5.33317C5.18344 5.33317 5.33268 5.18393 5.33268 4.99984C5.33268 4.81574 5.18344 4.6665 4.99935 4.6665C4.81525 4.6665 4.66602 4.81574 4.66602 4.99984C4.66602 5.18393 4.81525 5.33317 4.99935 5.33317Z" fill="#99A1AF" stroke="#99A1AF" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <span>{{ faqDetails.category }}</span>
                            </div>
                        </div>

                        <!-- Question -->
                        <div class="info-item mb-4" *ngIf="faqDetails?.question">
                            <div class="info-label mb-2">Question</div>
                            <div class="text-box">
                                {{ faqDetails.question }}
                            </div>
                        </div>

                        <!-- Answer -->
                        <div class="info-item" *ngIf="faqDetails?.answer">
                            <div class="info-label mb-2">Answer</div>
                            <div class="text-box">
                                {{ faqDetails.answer }}
                            </div>
                        </div>
                    </fieldset>
                </div>

                <!-- Right Column -->
                <div class="col-12 col-md-4">
                    <!-- Details Section -->
                    <fieldset class="content-fieldset mb-4">
                        <legend class="section-legend">Details</legend>
                        
                        <div class="info-item mb-3" *ngIf="faqDetails?.createdBy">
                            <div class="detail-row d-flex align-items-center gap-2 mb-2">
                                <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.5 10.5V9.5C9.5 8.96957 9.28929 8.46086 8.91421 8.08579C8.53914 7.71071 8.03043 7.5 7.5 7.5H4.5C3.96957 7.5 3.46086 7.71071 3.08579 8.08579C2.71071 8.46086 2.5 8.96957 2.5 9.5V10.5" stroke="#6A7282" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M6 5.5C7.10457 5.5 8 4.60457 8 3.5C8 2.39543 7.10457 1.5 6 1.5C4.89543 1.5 4 2.39543 4 3.5C4 4.60457 4.89543 5.5 6 5.5Z" stroke="#6A7282" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <span class="info-label">Created By</span>
                            </div>
                            <div class="info-value">{{ faqDetails.createdBy }}</div>
                        </div>

                        <div class="info-item mb-3" *ngIf="faqDetails?.createdDate">
                            <div class="detail-row d-flex align-items-center gap-2 mb-2">
                                <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_calendar)">
                                        <path d="M10 2H9V1C9 0.723858 8.77614 0.5 8.5 0.5C8.22386 0.5 8 0.723858 8 1V2H4V1C4 0.723858 3.77614 0.5 3.5 0.5C3.22386 0.5 3 0.723858 3 1V2H2C1.44772 2 1 2.44772 1 3V10C1 10.5523 1.44772 11 2 11H10C10.5523 11 11 10.5523 11 10V3C11 2.44772 10.5523 2 10 2Z" stroke="#6A7282" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M1 4H11" stroke="#6A7282" stroke-linecap="round" stroke-linejoin="round"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_calendar">
                                            <rect width="12" height="12" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                                <span class="info-label">Created Date</span>
                            </div>
                            <div class="info-value">{{ faqDetails.createdDate | date: 'MMM dd, yyyy' }}</div>
                        </div>

                        <div class="info-item mb-3" *ngIf="faqDetails?.lastModifiedBy">
                            <div class="detail-row d-flex align-items-center gap-2 mb-2">
                                <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.5 10.5V9.5C9.5 8.96957 9.28929 8.46086 8.91421 8.08579C8.53914 7.71071 8.03043 7.5 7.5 7.5H4.5C3.96957 7.5 3.46086 7.71071 3.08579 8.08579C2.71071 8.46086 2.5 8.96957 2.5 9.5V10.5" stroke="#6A7282" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M6 5.5C7.10457 5.5 8 4.60457 8 3.5C8 2.39543 7.10457 1.5 6 1.5C4.89543 1.5 4 2.39543 4 3.5C4 4.60457 4.89543 5.5 6 5.5Z" stroke="#6A7282" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <span class="info-label">Last Modified By</span>
                            </div>
                            <div class="info-value">{{ faqDetails.lastModifiedBy }}</div>
                        </div>

                        <div class="info-item" *ngIf="faqDetails?.lastModifiedDate">
                            <div class="detail-row d-flex align-items-center gap-2 mb-2">
                                <svg width="14" height="14" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_calendar_modified)">
                                        <path d="M10 2H9V1C9 0.723858 8.77614 0.5 8.5 0.5C8.22386 0.5 8 0.723858 8 1V2H4V1C4 0.723858 3.77614 0.5 3.5 0.5C3.22386 0.5 3 0.723858 3 1V2H2C1.44772 2 1 2.44772 1 3V10C1 10.5523 1.44772 11 2 11H10C10.5523 11 11 10.5523 11 10V3C11 2.44772 10.5523 2 10 2Z" stroke="#6A7282" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M1 4H11" stroke="#6A7282" stroke-linecap="round" stroke-linejoin="round"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_calendar_modified">
                                            <rect width="12" height="12" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                                <span class="info-label">Last Modified Date</span>
                            </div>
                            <div class="info-value">{{ faqDetails.lastModifiedDate | date: 'MMM dd, yyyy' }}</div>
                        </div>
                    </fieldset>
                </div>
            </fieldset>
        </div>
    </div>

    <!-- Confirmation Dialog -->
    <div class="confirmation-dialog-overlay" *ngIf="showConfirmDialog" (click)="cancelDeleteFAQ()">
        <div class="confirmation-dialog" (click)="$event.stopPropagation()">
            <div class="dialog-content">
                <p>{{ getConfirmDialogMessage() }}</p>
            </div>
            <div class="dialog-footer">
                <button class="btn btn-secondary" (click)="cancelDeleteFAQ()">Cancel</button>
                <button class="btn action-btn-purple" (click)="confirmDeleteFAQ()">Delete</button>
            </div>
        </div>
    </div>
</div>

